module.exports = __webpack_public_path__ + "static/media/trophy-3.c6e3d03b.svg";